import z from "zod";

export type EntityHistoryRemarkDialogInput = z.input<ReturnType<typeof EntityHistoryRemarkDialogSchema>>;
export type EntityHistoryRemarkDialogOutput = z.output<ReturnType<typeof EntityHistoryRemarkDialogSchema>>;

export const EntityHistoryRemarkDialogSchema = (remarkRequired: boolean) => z.object({
	remark: remarkRequired ? z.string().trim().min(1).max(255) : z.string(),
});
